/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Swal_TitleInputs */

const en_paste_swal_title = /** @type {(inputs: Paste_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste Events`)
};

const fr_paste_swal_title = /** @type {(inputs: Paste_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller les Evenements`)
};

const de_paste_swal_title = /** @type {(inputs: Paste_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse einfügen`)
};

const it_paste_swal_title = /** @type {(inputs: Paste_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla eventi`)
};

const ru_paste_swal_title = /** @type {(inputs: Paste_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить события`)
};

const es_paste_swal_title = /** @type {(inputs: Paste_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar eventos`)
};

const zh_cn2_paste_swal_title = /** @type {(inputs: Paste_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴事件`)
};

const ja_paste_swal_title = /** @type {(inputs: Paste_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを貼り付ける`)
};

const hi_paste_swal_title = /** @type {(inputs: Paste_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेस्ट इवेंट्स`)
};

const pt_pt2_paste_swal_title = /** @type {(inputs: Paste_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colar eventos`)
};

/**
* | output |
* | --- |
* | "Paste Events" |
*
* @param {Paste_Swal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_swal_title = /** @type {((inputs?: Paste_Swal_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Swal_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_swal_title(inputs)
	if (locale === "de") return de_paste_swal_title(inputs)
	if (locale === "it") return it_paste_swal_title(inputs)
	if (locale === "ru") return ru_paste_swal_title(inputs)
	if (locale === "es") return es_paste_swal_title(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_swal_title(inputs)
	if (locale === "ja") return ja_paste_swal_title(inputs)
	if (locale === "hi") return hi_paste_swal_title(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_swal_title(inputs)
	return en_paste_swal_title(inputs)
});